module.exports = __webpack_public_path__ + "static/media/руки в боки jeka.afabf244.png";